import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Vue from 'vue';

Vue.use(Vuetify)

const opts = {
    theme: {
        themes:{
            light:{
                primary: '#CB555B'
            }
        }
    }
}

export default new Vuetify(opts)